<template>
  <div id="app" :class="{ desktop: device === 'desktop' }">

    <div class="title">

        <div class="text">
          <p>
            <img v-if="device === 'desktop'" src="@/assets/img/logo.png" />
            <template v-else>
              ECFS 2021<br>
              <span>
              9-12 June, 2021<br>
              Milan, Italy
              </span>
            </template>
          </p>
        </div>

        <div class="navigation">
          <div>
            <b-nav vertical>
              <b-nav-item to="/help">
                Help
                <span><font-awesome-icon :icon="['fas', 'question-circle']" /></span>
              </b-nav-item>
              <b-nav-item>
                Sign In
                <span><font-awesome-icon :icon="['fad', 'sign-in-alt']" /></span>
              </b-nav-item>
            </b-nav>
          </div>
        </div>

    </div>

    <div class="menu">

      <div v-if="progress" class="program-progress"></div>

      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-8">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text toggle" @click="setSidebar(!sidebar)">
                  <font-awesome-icon :icon="['fas', 'bars']" />
                </span>
              </div>
              <input type="text" class="form-control" placeholder="Search the program ..." v-model="search" @keydown.enter.prevent="searchProgram()">
              <div class="input-group-append" @click="searchProgram()">
                <span class="input-group-text search">
                  <font-awesome-icon :icon="['fas', 'search']" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="body" :class="device">
      <div class="wrapper">
        <div class="menu" :style="{ 'margin-left': sidebar ? 0 : -300 + 'px' }">
          <div>

            <div class="head">
              <div v-if="$route.path.match(new RegExp('^\/program', 'i'))">
                <b-nav>
                  <b-nav-item 
                    :to="'/program/' + $route.params.key + '/horizontal'" 
                    :class="{ 'active': $route.path.match(new RegExp('horizontal$', 'i')) }"
                    @click="setProgramMode('horizontal'), setSidebar((device === 'mobile') ? !sidebar : sidebar)"
                    >
                    <span><font-awesome-icon :icon="['fas', 'grip-horizontal']" /></span>
                    Horizontal
                  </b-nav-item>
                  <b-nav-item 
                    :to="'/program/' + $route.params.key + '/vertical'" 
                    :class="{ 'active': $route.path.match(new RegExp('vertical$', 'i')) }"
                    @click="setProgramMode('vertical'), setSidebar((device === 'mobile') ? !sidebar : sidebar)"
                    >
                    <span><font-awesome-icon :icon="['fas', 'grip-vertical']" /></span>
                    Vertical
                  </b-nav-item>
                  <b-nav-item 
                    :to="'/program/' + $route.params.key + '/list'" 
                    :class="{ 'active': $route.path.match(new RegExp('list$', 'i')) }"
                    @click="setProgramMode('list'), setSidebar((device === 'mobile') ? !sidebar : sidebar)"
                    >
                    <span><font-awesome-icon :icon="['fas', 'grip-lines']" /></span>
                    List
                  </b-nav-item>
                </b-nav>
              </div>
            </div>

            <div class="body">

              <div class="navigation">
                <b-nav vertical>
                  <b-nav-item 
                    :to="'/program/' + day + '/' + program" 
                    :class="{ 'active': $route.path.match(new RegExp('^\/program', 'i')) }"
                    @click="setSidebar((device === 'mobile') ? !sidebar : sidebar)"
                    >
                    <span><font-awesome-icon :icon="['fad', 'calendar']" /></span>
                    Program
                  </b-nav-item>
                  <b-nav-item 
                    to="/persons" 
                    :class="{ 'active': $route.path.match(new RegExp('^\/persons', 'i')) }"
                    @click="setSidebar((device === 'mobile') ? !sidebar : sidebar)"
                    >
                    <span><font-awesome-icon :icon="['fad', 'users']" /></span>
                    Persons
                  </b-nav-item>
                  <b-nav-item 
                    to="/itinerary" 
                    :class="{ 'active': $route.path.match(new RegExp('^\/itinerary', 'i')) }"
                    @click="setSidebar((device === 'mobile') ? !sidebar : sidebar)"
                    >
                    <span><font-awesome-icon :icon="['fas', 'star']" /></span>
                    Itinerary
                  </b-nav-item>
                  <li class="nav-item" v-if="settings && settings.program">
                    <a class="nav-link" :href="settings.program.pdf" target="_blank">
                      <span><font-awesome-icon :icon="['fad', 'download']" /></span>
                      Download
                    </a>
                  </li>
                </b-nav>
              </div>

              <div class="filter" v-if="options.session_group">
                <div class="button" v-b-toggle:collapse-groups>
                  <p>Session Tracks</p>
                  <span v-if="filter.session_group.length" class="reset"  @click.stop="resetFilter('session_group')">Reset</span>
                  <span class="open"><font-awesome-icon :icon="['fas', 'sort-down']" /></span>
                  <span class="closed"><font-awesome-icon :icon="['fas', 'sort-up']" /></span>
                </div>
                <b-collapse class="items" id="collapse-groups">
                  <b-nav vertical>
                    <b-nav-item 
                      v-for="(gval, gkey) in options.session_group" 
                      :key="gkey" 
                      :class="{ active: filter.session_group.includes(gval.id) }"
                      @click.prevent="updateFilter({ group: 'session_group', id: gval.id })">
                      <span><font-awesome-icon :icon="['fas', filter.session_group.includes(gval.id) ? 'check-square' : 'square']" /></span>
                      {{ gval.name }}
                    </b-nav-item>
                  </b-nav>
                </b-collapse>
              </div>

              <div class="filter" v-if="options.session_type">
                <div class="button" v-b-toggle:collapse-types>
                  <p>Session Types</p>
                  <span v-if="filter.session_type.length" class="reset"  @click.stop="resetFilter('session_type')">Reset</span>
                  <span class="open"><font-awesome-icon :icon="['fas', 'sort-down']" /></span>
                  <span class="closed"><font-awesome-icon :icon="['fas', 'sort-up']" /></span>
                </div>
                <b-collapse class="items" id="collapse-types">
                  <b-nav vertical>
                    <b-nav-item 
                      v-for="(tval, tkey) in options.session_type" 
                      :key="tkey"
                      :class="{ active: filter.session_type.includes(tval.id) }"
                      @click.prevent="updateFilter({ group: 'session_type', id: tval.id })">
                      <span><font-awesome-icon :icon="['fas', filter.session_type.includes(tval.id) ? 'check-square' : 'square']" /></span>
                      {{ tval.name }}
                    </b-nav-item>
                  </b-nav>
                </b-collapse>
              </div>

              <div class="filter" v-if="rooms">
                <div class="button" v-b-toggle:collapse-rooms>
                  <p>Rooms</p>
                  <span v-if="filter.room.length" class="reset" @click.stop="resetFilter('room')">Reset</span>
                  <span class="open"><font-awesome-icon :icon="['fas', 'sort-down']" /></span>
                  <span class="closed"><font-awesome-icon :icon="['fas', 'sort-up']" /></span>
                </div>
                <b-collapse class="items" id="collapse-rooms">
                  <b-nav vertical>
                    <b-nav-item 
                      v-for="(rval, rkey) in rooms" 
                      :key="rkey"
                      :class="{ active: filter.room.includes(rval.id) }"
                      @click.prevent="updateFilter({ group: 'room', id: rval.id })">
                      <span><font-awesome-icon :icon="['fas', filter.room.includes(rval.id) ? 'check-square' : 'square']" /></span>
                      {{ rval.name }}
                    </b-nav-item>
                  </b-nav>
                </b-collapse>
              </div>

            </div>
          </div>
        </div>
        <div class="content" @click="closeSidebar()">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters(['device', 'width', 'sidebar', 'day', 'program', 'rooms', 'options']),
    search: {
      get() {
        return this.$store.state.search;
      },
      set(value) {
        this.setSearch(value);
      }
    },
  },
  methods: {
    ...mapMutations(['setDevice', 'setSidebar', 'setProgramMode', 'setSearch', 'setResults']),
    ...mapActions(['initializeProgram', 'updateFilter', 'resetFilter', 'getResults']),
    searchProgram() {
      if (this.$store.state.search != '') {
        if (!this.$route.path.match(/^\/results/)) {
          this.setResults([]);
          this.$router.push('/results');
        }
        this.getResults();
      }
    },
    closeSidebar() {
      if (this.device === 'mobile') this.setSidebar(false);
    },
    windowWidth() {
      if (window.innerWidth > 576) {
        if (this.device !== 'desktop') this.setSidebar(true);
        this.setDevice('desktop');
      } else {
        if (this.device !== 'mobile') this.setSidebar(false);
        this.setDevice('mobile');
      }
    }
  },
  async created() {
    this.windowWidth();
    addEventListener('resize', this.windowWidth);
  },
  destroyed() {
    removeEventListener('resize', this.windowWidth);
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/app';
</style>
